import { BcCalendarEvent, BcCalendarResource, BcCalendarSettings } from '@bayclubs/calendar';
import { BcStateContext, BcStateForm, BcStateListContext } from '@bayclubs/state';
import { ClassesCalendarFiltersModel } from '../model/classes-calendar-filters.model';

export const CLASSES_CALENDAR_FEATURE_KEY = 'classesCalendar';

export interface ClassesCalendarStateModel {
    calendarSettings: BcStateContext<BcCalendarSettings>;
    calendarEvents: BcStateListContext<BcCalendarEvent>;
    calendarResources: BcStateListContext<BcCalendarResource>;
    filters: BcStateForm<ClassesCalendarFiltersModel>;
    selectedClubId: string;
}
